import * as React from 'react';
import classnames from 'classnames';
import { useIntl } from '@grandvisionhq/state';
import Loader from './Loader.js';

const LoaderScreen = ({ height =75 , delay , className  })=>{
    const [hasTimeoutPassed, setHasTimeoutPassed] = React.useState(true);
    const intl = useIntl();
    React.useEffect(()=>{
        if (delay) {
            setHasTimeoutPassed(false);
            const timeout = setTimeout(()=>{
                setHasTimeoutPassed(true);
            }, delay);
            return ()=>clearTimeout(timeout)
            ;
        }
    }, [
        delay
    ]);
    return hasTimeoutPassed ? /*#__PURE__*/ React.createElement("div", {
        "data-t": "loader-screen",
        className: classnames('loader-screen', className),
        style: {
            height: `${height}vh`
        },
        "aria-busy": true
    }, /*#__PURE__*/ React.createElement("div", {
        className: "loader-screen__content"
    }, /*#__PURE__*/ React.createElement(Loader, null), /*#__PURE__*/ React.createElement("p", {
        className: "loader-screen__text"
    }, intl.getLabel('common.loadingText')))) : null;
};
var LoaderScreen$1 = LoaderScreen;

export { LoaderScreen$1 as default };
//# sourceMappingURL=LoaderScreen.js.map
